import React from "react";
import { Button, Empty, InputNumber, List, Popconfirm, Typography } from "antd";

const HQInboundScanner = ({
  inboundItems,
  onChangeQty,
  onRemove,
  onClear,
  onConfirm,
  loading,
}) => {
  const items = Object.values(inboundItems || {});
  const totalQty = items.reduce(
    (sum, item) => sum + parseFloat(item.quantity || 0),
    0
  );

  return (
    <div className="hqInbound">
      <div className="hqInboundHeader">
        <Typography.Text strong>HQ Inbound Items</Typography.Text>
        <Typography.Text type="secondary">
          {items.length} products / {totalQty.toFixed(2)} total qty
        </Typography.Text>
      </div>

      <List
        locale={{ emptyText: <Empty description="Scan product QR codes or barcodes" /> }}
        dataSource={items}
        renderItem={(item) => (
          <List.Item
            actions={[
              <InputNumber
                key="qty"
                min={0}
                value={item.quantity}
                onChange={(value) => {
                  onChangeQty(item.id, value);
                }}
              />,
              <Popconfirm
                key="remove"
                title="Remove item?"
                onConfirm={() => {
                  onRemove(item.id);
                }}
              >
                <Button type="link" danger>
                  Remove
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              avatar={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                  alt={item.product_name}
                  style={{
                    width: 48,
                    height: 48,
                    objectFit: "contain",
                    borderRadius: 4,
                    background: "#fff",
                  }}
                />
              }
              title={item.product_name}
              description={item.unit || "unit"}
            />
          </List.Item>
        )}
      />

      <div className="hqInboundActions">
        <Button onClick={onClear}>Clear</Button>
        <Button type="primary" loading={loading} onClick={onConfirm}>
          Confirm Inbounded
        </Button>
      </div>
    </div>
  );
};

export default HQInboundScanner;
